import { type ReplaceList, useLabelStore } from "../stores/label.ts";

export function label(key: string, replace: ReplaceList = {}) {
    const string = useLabelStore().get(key, replace);
    return string.toString();
}
